export default function ProgressBar({ value, max = 100, label }) {
  const safeMax = Math.max(Number(max) || 0, 1)
  const safeValue = Math.min(Math.max(Number(value) || 0, 0), safeMax)
  const percentage = Math.round((safeValue / safeMax) * 100)

  return (
    <div className="progress-group">
      {label && <div className="progress-label"><span>{label}</span><span>{percentage}%</span></div>}
      <div className="progress-track" role="progressbar" aria-label={label || 'Progress'} aria-valuemin="0" aria-valuemax={safeMax} aria-valuenow={safeValue}>
        <span className="progress-value" style={{ width: `${percentage}%` }} />
      </div>
    </div>
  )
}
